module.exports = __webpack_public_path__ + "static/media/menu.a6f6f4eb.svg";